import { render, staticRenderFns } from "./SwitchLocale.vue?vue&type=template&id=7fee87e6&"
import script from "./SwitchLocale.vue?vue&type=script&lang=js&"
export * from "./SwitchLocale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports